import { useMemo } from 'react';
import { formatAffairAmount } from '../affairFormatters';
import { calculateAffairMetrics } from '../affairMetrics';

export default function AffairDashboard({ affairs }) {
  const metrics = useMemo(() => calculateAffairMetrics(affairs), [affairs]);
  const cards = [
    ['A analyser', metrics.toAnalyze],
    ['Montant potentiel', formatAffairAmount(metrics.potentialAmount)],
    ['Devis à terminer', metrics.quotesToFinish],
    ['Réponses attendues', metrics.awaitedResponses],
    ['Relances à faire', metrics.followUpsToDo, metrics.followUpsToDo ? 'warning' : ''],
    ['Demandes acceptées à démarrer', metrics.acceptedToStart, metrics.acceptedToStart ? 'info' : ''],
  ];
  return <section className="affair-dashboard" aria-label="Indicateurs du pipeline">{cards.map(([label, value, tone]) => <article className={`affair-dashboard__card ${tone ? `affair-dashboard__card--${tone}` : ''}`} key={label}><span>{label}</span><strong>{value}</strong></article>)}</section>;
}
